import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

interface EOfficeState {
    data: any | null;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "list" | null;
}

const initialState: EOfficeState = {
    data: null,
    loading: "idle",
    error: null,
    action: null,
};

export const getEOfficeData: any = createAsyncThunk(
    "eOffice/list",
    async (requestBody: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.E_OFFICE.FIND_ALL, requestBody);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const eOfficeSlice = createSlice({
    name: "eOffice",
    initialState: initialState,
    reducers: {
        resetAll: (state: any) => {
            state.loading = "idle";
            state.error = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEOfficeData.pending, (state) => {
                state.loading = "pending";
                state.error = null;
                state.action = "list";
            })
            .addCase(getEOfficeData.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.data = action.payload;
                state.error = null;
            })
            .addCase(getEOfficeData.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload;
            });
    },
});

export const { resetAll } = eOfficeSlice.actions;
export default eOfficeSlice.reducer;

